/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Icon, CustomValidation, Button } from 'sarsaparilla';

const propTypes = {
    index: PropTypes.number,
    removeLeader: PropTypes.func,
    handleAlternateLeaderChange: PropTypes.func,
    leader: PropTypes.shape({
        fName: PropTypes.string,
        mName: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        lName: PropTypes.string,
    }),
    className: PropTypes.string,
    handleAlternateLeaderValidation: PropTypes.func.isRequired,
    alternateLeaderValidatorMethod: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
};

const defaultProps = {
    isDisabled: false,
    className: '',
};

export default class AlternatePermitHolderEntry extends React.Component {
    constructor(props) {
        super(props);
        this.onClickRemove = this.onClickRemove.bind(this);
    }

    onClickRemove() {
        const index = parseInt(this.props.index, 10);
        this.props.removeLeader(index);
    }

    handleChange(event) {
        const input = event.target.value;
        const id = event.target.id;
        this.props.handleAlternateLeaderChange(this.props.index, id, input);
    }

    renderRemoveLeaderButton() {
        if (this.props.isDisabled) {
            return <div />;
        }

        return (
            <div className="alternate-group-leader">
                <Button
                    type="button"
                    appearance="subtle-danger"
                    onClick={this.onClickRemove}
                    iconBeforeElement={<Icon iconName="delete" />}
                    aria-label="Remove"
                />
            </div>
        );
    }

    render() {
        const { leader } = this.props;
        return (
            <div className="permit-alt-input-wrap">
                <div className="permit-alt-header-wrap">
                    <div className="permit-alt-header">
                        Alternate Permit Holder #{this.props.index + 1}
                    </div>
                    {this.renderRemoveLeaderButton()}
                </div>

                <div className="rec-form-item-wrap">
                    <label htmlFor="other-email">Email Address</label>
                    <input
                        id="other-email"
                        type="text"
                        className={this.props.className}
                        value={leader.email}
                        onChange={(e) => {
                            this.handleChange(e);
                        }}
                        readOnly={this.props.isDisabled}
                        disabled={this.props.isDisabled}
                    />
                    <CustomValidation
                        value={get(leader, 'email', '')}
                        displayInSummary
                        customValidator={this.props.alternateLeaderValidatorMethod}
                        onValidated={this.props.handleAlternateLeaderValidation}
                        controlLabel="Alternate Permit Holder Email Address"
                    />
                </div>
            </div>
        );
    }
}

AlternatePermitHolderEntry.propTypes = propTypes;
AlternatePermitHolderEntry.defaultProps = defaultProps;
